import { render } from "./PathwaysResultsHeader.vue?vue&type=template&id=38106606"
import script from "./PathwaysResultsHeader.vue?vue&type=script&lang=js"
export * from "./PathwaysResultsHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__